import { TableCell, TableRow } from "@material-ui/core";
import { DatatablesFooterServerSide, TableAction } from "App/Component/ui";
import { getComparator, stableSort } from "App/Component/ui/datatable/utils";
import { useDatatables } from "App/hooks";
import { FreezeTable } from "components/organism";
import { headCellsHeader } from "./helpers";

export default function BundleHeaderTable({
	rows,
	handleSelect,
	totalData,
	resetPagination,
	setNewData,
	pagination,
	onPrevious,
	onNext,
	handleClickPageNumber,
	handleChangeLimit,
	loading,
	formFilter,
	setFormFilter,
}) {
	const { order, orderBy, handleRequestSort, length } = useDatatables({
		rows: rows,
		orderByDefault: "date",
		orderByRow: ["date", "id"],
	});

	return (
		<>
			<FreezeTable
				headCells={headCellsHeader}
				handleRequestSort={handleRequestSort}
				order={order}
				length={length}
				orderBy={orderBy}
			>
				{stableSort(rows, getComparator(order, orderBy)).map((row, index) => {
					return (
						<TableRow key={index}>
							<TableCell align="center">{index + 1}</TableCell>
							<TableCell align="center">
								<div
									style={{
										display: "flex",
										justifyContent: "center",
									}}
								>
									<TableAction
										isUpdate={false}
										isDelete={false}
										isSelect={true}
										clickSelect={() => handleSelect(row)}
									/>
								</div>
							</TableCell>
							<TableCell align="center">{row?.id_bundle}</TableCell>
							<TableCell align="center">
								{row?.request === null ||
								row?.request === undefined ||
								row?.request === ""
									? ""
									: JSON.stringify(row?.request)}
							</TableCell>
							<TableCell align="center">
								{row?.response === null ||
								row?.response === undefined ||
								row?.response === ""
									? ""
									: JSON.stringify(row?.response)}
							</TableCell>
							<TableCell align="center">{row?.inserted_user}</TableCell>
							<TableCell align="center">{row?.inserted_date}</TableCell>
						</TableRow>
					);
				})}
				{rows.length === 0 && (
					<TableRow>
						<TableCell align="center" colSpan={headCellsHeader.length}>
							Tidak ada data
						</TableCell>
					</TableRow>
				)}
			</FreezeTable>

			<DatatablesFooterServerSide
				totalData={totalData}
				pagination={pagination}
				handleChangeLimit={handleChangeLimit}
				onPrevious={onPrevious}
				onNext={onNext}
				currentPage={pagination.page}
				handleClickPageNumber={handleClickPageNumber}
			/>
		</>
	);
}
